import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../common/models/Message";
import { EmployeesState } from "../models/EmployeesState";

const setMessage = (state: EmployeesState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;